import qore from "refractor/qore";
export default qore;